export default {
  'categories.shoes': 'Zapatos',
  'categories.hoodies': 'Sudaderas y jerséis',
  'categories.tshirts': 'Camisetas',
  'categories.jackets': 'Chaquetas',
  'categories.pants': 'Pantalones y shorts',
  'categories.headwear': 'Gorras y sombreros',
  'categories.sets': 'Conjuntos',
  'categories.underwear': 'Ropa interior',
  'categories.jersey': 'Camiseta deportiva',
  'categories.accessories': 'Accesorios',
  'categories.bags': 'Bolsos',
  'categories.belts': 'Cinturones',
  'categories.perfumes': 'Perfumes',
  'categories.other': 'Otras cosas',

  'nav.guides': 'Guías',
  'nav.categories': 'Categorías',
  'nav.shipping': 'Envío',
  'nav.warehouse': 'Almacén',
  'nav.coupons': 'Cupones',
  'nav.safety': 'Seguridad',
  'nav.buyNow': 'Comprar ahora',
  'nav.home': 'Inicio',
  'nav.shoppingGuide': 'Guía de compras',
  'nav.about': 'Acerca de',

  'hero.eyebrow': 'CENTRO DE RECURSOS USFANS SPREADSHEET',
  'hero.title': 'USFans Spreadsheet — encuentra, compara y explora recursos más rápido',
  'hero.subtitle': 'Explora los recursos de USFans spreadsheet, guías de investigación de productos, reseñas, información de envío, guías de almacén, cupones, consejos de seguridad y tutoriales prácticos — todo organizado en un solo lugar.',
  'hero.ctaPrimary': 'Explorar USFans Spreadsheet',
  'hero.ctaSecondary': 'Ver guías de USFans',
  'hero.searchPlaceholder': 'Busca hojas de cálculo, productos, vendedores o guías...',
  'hero.trust': 'Recurso independiente • Guías prácticas • Actualizado con regularidad',

  'trust.1.title': 'USFans Spreadsheet',
  'trust.1.desc': 'Recursos organizados e información práctica.',
  'trust.2.title': 'Investigación de productos',
  'trust.2.desc': 'Compara productos, vendedores y recursos útiles.',
  'trust.3.title': 'Envío y almacén',
  'trust.3.desc': 'Comprende el envío, el almacén y la preparación.',
  'trust.4.title': 'Seguridad primero',
  'trust.4.desc': 'Verifica enlaces, vendedores, precios y pagos.',

  'category.title': 'Explora las categorías de productos',
  'category.subtitle': 'Salta directamente a cualquier categoría del sitio principal.',
  'category.dropdownLabel': 'Elige una categoría',
  'category.dropdownPlaceholder': 'Selecciona una categoría para continuar...',

  'about.title': '¿Qué es una USFans Spreadsheet?',
  'about.copy': 'Una USFans spreadsheet es un recurso estructurado que se usa para organizar información de productos, enlaces, vendedores, categorías e investigación de compras relacionada. Nuestro objetivo es hacer que esa información sea más fácil de descubrir, entender y comparar.',
  'about.cta': 'Aprende cómo funcionan las hojas de USFans',

  'explore.title': 'Tu centro de investigación de USFans Spreadsheet',
  'explore.subtitle': 'Todo organizado en un solo lugar, de la investigación a la seguridad.',
  'explore.1.title': 'USFans Spreadsheet',
  'explore.2.title': 'Investigación de productos',
  'explore.3.title': 'Recursos de vendedores',
  'explore.4.title': 'Reseñas',
  'explore.5.title': 'Envío',
  'explore.6.title': 'Almacén',
  'explore.7.title': 'Cupones',
  'explore.8.title': 'Seguridad',

  'guides.title': 'Guías populares de USFans',
  'guides.subtitle': 'Guías prácticas y originales para ayudarte a decidir mejor.',
  'guides.readMore': 'Leer la guía',

  'pillars.eyebrow': 'Guías pilar',
  'pillars.title': 'Guías pilar de USFans Spreadsheet',
  'pillars.subtitle': 'Artículos originales y en profundidad sobre los temas centrales: conceptos básicos, búsqueda, productos, vendedores y comparación.',

  'module.review.title': 'Reseña de USFans',
  'module.review.desc': 'Qué saber antes de usarlo: funciones, envío, almacén y pago.',
  'module.shipping.title': 'Guía de costes de envío',
  'module.shipping.desc': 'Cómo afectan el peso, el destino y el método al coste de envío.',
  'module.coupon.title': 'Cupón y código de descuento',
  'module.coupon.desc': 'Cómo funcionan los cupones y dónde verificar las promociones vigentes.',
  'module.warehouse.title': 'Guía del almacén',
  'module.warehouse.desc': 'Almacenamiento, inspección, consolidación y embalaje explicados.',
  'module.safety.title': '¿Es legítimo USFans?',
  'module.safety.desc': 'Una lista práctica para verificar enlaces, vendedores y pagos.',

  'cta.title': '¿Listo para explorar los recursos de USFans Spreadsheet?',
  'cta.text': 'Empieza por el centro de USFans Spreadsheet, explora guías y comparaciones prácticas y continúa al sitio principal cuando quieras saber más.',
  'cta.primary': 'Explorar USFans Spreadsheet',
  'cta.secondary': 'Visitar el sitio principal',

  'footer.tagline': 'Un centro de recursos independiente sobre USFans Spreadsheet.',
  'footer.resources': 'Recursos',
  'footer.company': 'Empresa',
  'footer.legal': 'Legal',
  'footer.languages': 'Idiomas',
  'footer.disclaimer': 'Este sitio web es un recurso informativo independiente y no está necesariamente afiliado ni respaldado por USFans, salvo que se indique explícitamente.',
};